
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { RouteAction } from '@core/action/action';
import { ParametrizacaoListComponent } from './pages/parametro-list/parametrizacao-list.component';
import { ParametrizacaoFormComponent } from './pages/parametro-form/parametrizacao-form.component';

const routes: Routes = [
  {
    path: '',
    component: ParametrizacaoListComponent,
    canActivate: [AuthGuardService],
    data: {
      headerPage: {
        titlePage: '',
        subTitlePage: '',
      },
    },
  },

  {
    path: ':cadastrar',
    component: ParametrizacaoFormComponent,
    data: {
      acao: RouteAction.Inserir
    },
  },
  {
    path: 'editar/:id',
    component: ParametrizacaoFormComponent,
    data: {
      acao: RouteAction.Editar,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParametrizacaoRoutingModule { }
